var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Collapse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71216 3.40929L11.0908 9.7879C11.208 9.90507 11.208 10.095 11.0908 10.2122L4.71217 16.5909C4.52316 16.7799 4.2 16.646 4.2 16.3787V3.62144C4.2 3.35414 4.52317 3.22029 4.71216 3.40929ZM3 3.62144C3 2.28506 4.61573 1.6158 5.56069 2.56076L11.9393 8.93937C12.5251 9.52517 12.5251 10.4749 11.9393 11.0607L5.5607 17.4394C4.61574 18.3844 3 17.7151 3 16.3787V3.62144ZM11.4248 2.57583C11.1905 2.34151 10.8106 2.3415 10.5762 2.5758C10.3419 2.81011 10.3419 3.19001 10.5762 3.42433L16.8687 9.71728C17.0249 9.87349 17.0249 10.1267 16.8687 10.2829L10.5762 16.5758C10.3419 16.8102 10.3419 17.1901 10.5762 17.4244C10.8106 17.6587 11.1905 17.6587 11.4248 17.4243L17.7172 11.1314C18.342 10.5066 18.342 9.49361 17.7172 8.86878L11.4248 2.57583Z",
    fill: "#737373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.408a065a46aef67d15af5d2214272431.svg";
export { ForwardRef as ReactComponent };